import { Component, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { NumberFormatPipe } from '@iot-platform/pipes';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'grid-engine-count-cell',
  templateUrl: './count-cell.component.html',
  imports: [NumberFormatPipe],
  providers: [NumberFormatPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./count-cell.component.scss']
})
export class CountCellComponent implements ICellRendererAngularComp {
  params: WritableSignal<ICellRendererParams> = signal(null);

  agInit(params: ICellRendererParams): void {
    this.params.set(params);
  }

  refresh(): boolean {
    return false;
  }
}
